import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Panel } from "@/components/common";
import { BadgeCheck } from "lucide-react";

function Line({ ok, label, testId }) {
  return (
    <div data-testid={testId} className="flex items-center gap-2">
      <span className={ok ? "text-emerald-400" : "text-rose-400"}>{ok ? "PASS" : "CHECK"}</span>
      <span className="text-slate-300">{label}</span>
    </div>
  );
}

export function ProductionVerificationPanel() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["production-verification"],
    queryFn: async () => (await api.get("/system/production-verification")).data,
  });
  return (
    <Panel title="Production verification (read-only)" testId="production-verification-panel" actions={<BadgeCheck className="w-4 h-4 text-slate-500" />}>
      <div className="p-4 space-y-1.5 text-xs">
        {isLoading && <div className="text-slate-500">Checking…</div>}
        {isError && <div data-testid="prodver-error" className="text-rose-400">Could not load verification.</div>}
        {data && (
          <>
            <Line testId="prodver-mfa" ok={data.owner.mfa_enabled} label="MFA (TOTP) enabled for the owner" />
            <Line testId="prodver-recovery" ok={data.owner.recovery_codes_enabled && data.owner.recovery_codes_unused > 0}
              label={`Recovery codes: ${data.owner.recovery_codes_unused} unused of ${data.owner.recovery_codes_total}`} />
            <Line testId="prodver-password" ok={!data.owner.password_change_required} label="Owner password set by owner" />
            <Line testId="prodver-single-owner" ok={data.owner.owner_accounts === 1 && !data.owner.owner_setup_endpoint_enabled} label="Single owner, setup endpoint disabled" />
            <Line testId="prodver-capital" ok={data.capital.separated} label="Real capital ledger and paper-trading ledger are separate" />
            <Line testId="prodver-live-off" ok={!data.safety.live_trading_enabled && !data.safety.sharekhan_live_enabled} label="Live trading and Sharekhan live connection OFF" />
            <div data-testid="prodver-callback" className="pt-1 text-slate-500 font-mono break-all">Callback: {data.published_callback_url}</div>
          </>
        )}
      </div>
    </Panel>
  );
}
